var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-root"},[_vm._t("default"),_vm._v(" "),_c('modal-login'),_vm._v(" "),_c('v-msg')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }